// Badge primitive — port of design/v3/Primitives.jsx (Badge).

import type { CSSProperties, ReactNode } from 'react';

export type BadgeVariant =
  | 'default'
  | 'primary'
  | 'success'
  | 'warning'
  | 'danger'
  | 'info'
  | 'baemin'
  | 'coupang'
  | 'yogiyo';

const map: Record<BadgeVariant, { bg: string; fg: string }> = {
  success: { bg: 'var(--success-bg)', fg: '#14532D' },
  warning: { bg: 'var(--warning-100)', fg: '#78350F' },
  danger: { bg: 'var(--danger-bg)', fg: '#7F1D1D' },
  info: { bg: 'var(--info-bg)', fg: '#075985' },
  default: { bg: 'var(--bg-subtle)', fg: 'var(--fg-2)' },
  primary: { bg: 'var(--primary-bg)', fg: 'var(--primary-strong)' },
  baemin: { bg: 'var(--platform-baemin)', fg: '#fff' },
  coupang: { bg: 'var(--platform-coupang)', fg: '#fff' },
  yogiyo: { bg: 'var(--platform-yogiyo)', fg: '#fff' },
};

export interface BadgeProps {
  children: ReactNode;
  variant?: BadgeVariant;
  dot?: boolean;
  style?: CSSProperties;
}

export function Badge({ children, variant = 'default', dot, style }: BadgeProps) {
  const v = map[variant];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: '2px 9px',
        borderRadius: 999,
        fontSize: 12,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        background: v.bg,
        color: v.fg,
        ...style,
      }}
    >
      {dot && (
        <span
          style={{
            width: 6,
            height: 6,
            borderRadius: 999,
            background: v.fg,
            opacity: 0.7,
          }}
        />
      )}
      {children}
    </span>
  );
}
